<template>
  <div v-if="show">
    <b-dropdown v-if="show == 'menu'" class="header-menu" size="sm" variant="clear" right no-caret>
      <template slot="button-content"><i class="fas fa-ellipsis-v"/></template>
      <b-dropdown-item @click="currentTemplateId = '*new*'">Add design</b-dropdown-item>
    </b-dropdown>
    <div v-else class="template-chooser-row">
      <div class="hscroll">
        <b-radio-group v-model="currentTemplateId" class="template-choices" button-variant="clear" buttons>
          <b-radio v-for="pt in productTemplates" :key="pt.id" :value="pt.id">
            <div class="embedded-input-container" v-if="isEditingTemplateName && currentTemplateId === pt.id">
              <b-input autofocus @input="updateDesignName($event, pt)" :value="pt.name" class="embedded-input"/>
              <span @click="acceptEdits" class="ok"><i class="fas fa-check-circle"></i></span>
              <span @click="cancelEdits" class="cancel"><i class="fas fa-times-circle"></i></span>
            </div>
            <template v-else>{{pt.name}}</template>
          </b-radio>
          <b-radio v-if="showAddButton" value="*new*">
            <i class="fas fa-plus"/>
          </b-radio>
        </b-radio-group>
      </div>
      <b-dropdown v-if="showDropdown" class="template-chooser-menu" size="sm" variant="clear" right no-caret>
        <template slot="button-content"><i class="fas fa-ellipsis-v"/></template>
        <b-dropdown-item @click="isEditingTemplateName=true">Rename design</b-dropdown-item>
        <b-dropdown-item @click="cloneCurrentDesign">Clone design</b-dropdown-item>
        <b-dropdown-item @click="deleteCurrentDesign">Delete design</b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '~scss/colors.scss';

.header-menu {
  position: absolute;
  right: 0em;
  top: 0em;
}

.template-chooser-row {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  max-width: 100%;
  .hscroll {
    flex-basis: auto;
    flex-shrink: 1;
    overflow-x: scroll;
    padding-bottom: 1em;

    // Hide scrollbar when possible
    -ms-overflow-style: none;
    scrollbar-width: none; // Firefox
    &::-webkit-scrollbar { // Chrome etc
      display: none;
    }
  }
}
.template-chooser-menu {
  margin: 5px 0;
  padding-bottom: 1em;
  flex-basis: 20px;
}

.embedded-input {
  border: 1px solid $gray-0;
  border-radius: 0;
  margin: -3px -6px;
  padding: 2px 4px;
  line-height: 13px;
  width: 15em;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 2px;
}

.embedded-input-container {
  position: relative;
  span {
    position: absolute;
    top: 4px;
  }
  span.ok {
    color: green;
    right: 16px;
  }
  span.cancel {
    color: red;
    right: 0px;
  }
}
</style>

<style lang="scss">
  @import '~scss/colors';
// unscoped, to affect the button group
.template-choices {
 .btn-clear {
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 8px 15px;
    height: auto;
    &.active {
      background: $gray-2;
    }
  }
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: {noEdit: {type: Boolean}},
  data() {
    return {
      isEditingTemplateName: false,
      newName: null
    };
  },
  computed: {
    ...mapGetters([
      "productTemplates",
      "productTemplate",
      "isAdmin",
      "flags",
      "userSettings"
    ]),
    currentTemplateId: {
      get() {
        return this.productTemplate.id;
      },
      async set(id) {
        if (this.isEditingTemplateName) {
          // "stop" editing right away, instead of waiting until save is complete
          this.isEditingTemplateName = false;
          this.acceptEdits();
        }
        if (id === '*new*') {
          await this.addProductTemplate();
          this.isEditingTemplateName = true;
        } else {
          await this.setCurrentProductTemplate(id);
        }
      }
    },
    showDropdown() {
      return this.isAdmin && !this.noEdit;
    },
    showAddButton() {
      return this.allProductTemplatesSaved && !this.noEdit;
    },
    allProductTemplatesSaved() {
      return this.productTemplates.every(pt => pt.id);
    },
    show() {
      // This component must be enabled with a flag.
      // Also, if the user has "restrictDesign" set, and a template chosen,
      // hide the component (even from admins -- this lets admins "experience"
      // how a restricted design would appear).
      let single = this.productTemplates.length <= 1,
        restricted = this.userSettings.restrictDesign && this.productTemplate;
      if (restricted || (this.noEdit && single)) {
        // Hide
        return null;
      } else if (single) {
        return 'menu';
      } else {
        return 'component';
      }
    }
  },
  methods: {
    ...mapActions([
      "updateProductTemplate",
      "deleteProductTemplates",
      "setCurrentProductTemplate",
      "cloneProductTemplate",
      "addProductTemplate"
    ]),
    async acceptEdits() {
      await this.updateProductTemplate({...this.productTemplate, name: this.newName});
      this.newName = null;
      this.isEditingTemplateName = false;
    },
    cancelEdits() {
      this.newName = null;
      this.isEditingTemplateName = false;
    },
    deleteCurrentDesign() {
      this.deleteProductTemplates()
    },
    updateDesignName(value, product_template) {
      this.newName = value;
    },
    cloneCurrentDesign() {
      this.cloneProductTemplate();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/shared/TemplateChooser.vue